import { useCopy } from "@/i18n/LocaleContext";

const COPY = {
  en: {
    hubs: "Hubs · Drums · Brakes",
    suspension: "Suspension Parts",
    jacks: "Jacks & Couplers",
    tires: "Tires & Wheels",
  },
  es: {
    hubs: "Mazas · Tambores · Frenos",
    suspension: "Piezas de suspensión",
    jacks: "Gatos y acopladores",
    tires: "Neumáticos y ruedas",
  },
};

type SvgProps = React.SVGProps<SVGSVGElement>;

export function HeroAxleArt(props: SvgProps) {
  return (
    <svg viewBox="0 0 720 520" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
      <defs>
        <linearGradient id="hero-tire" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#2a2f38" />
          <stop offset="100%" stopColor="#0f1217" />
        </linearGradient>
        <linearGradient id="hero-rim" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#e5e7eb" />
          <stop offset="100%" stopColor="#9ca3af" />
        </linearGradient>
        <linearGradient id="hero-hub" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#f3f4f6" />
          <stop offset="100%" stopColor="#6b7280" />
        </linearGradient>
        <linearGradient id="hero-axle-tube" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#3a3f49" />
          <stop offset="50%" stopColor="#1d2026" />
          <stop offset="100%" stopColor="#0a0c0f" />
        </linearGradient>
        <linearGradient id="hero-spring" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#4b5563" />
          <stop offset="100%" stopColor="#1f2937" />
        </linearGradient>
      </defs>
      <ellipse cx="360" cy="430" rx="320" ry="22" fill="#000" opacity="0.35" />
      <rect x="120" y="248" width="480" height="34" rx="6" fill="url(#hero-axle-tube)" />
      <rect x="120" y="248" width="480" height="6" fill="#fff" opacity="0.06" />
      <g>
        <path d="M260 240 Q360 215 460 240" stroke="url(#hero-spring)" strokeWidth="8" fill="none" strokeLinecap="round" />
        <path d="M275 248 Q360 226 445 248" stroke="url(#hero-spring)" strokeWidth="6" fill="none" strokeLinecap="round" opacity="0.85" />
        <path d="M290 256 Q360 238 430 256" stroke="url(#hero-spring)" strokeWidth="5" fill="none" strokeLinecap="round" opacity="0.7" />
        <rect x="352" y="232" width="16" height="22" rx="2" fill="#111418" />
        <circle cx="360" cy="220" r="5" fill="#ff2800" />
      </g>
      <rect x="320" y="240" width="4" height="50" fill="#111" />
      <rect x="396" y="240" width="4" height="50" fill="#111" />
      <g transform="translate(150,265)">
        <circle cx="0" cy="0" r="118" fill="url(#hero-tire)" />
        <circle cx="0" cy="0" r="118" fill="none" stroke="#000" strokeWidth="2" opacity="0.6" />
        {Array.from({ length: 28 }).map((_, i) => {
          const a = (i / 28) * Math.PI * 2;
          return <line key={i} x1={Math.cos(a) * 112} y1={Math.sin(a) * 112} x2={Math.cos(a) * 102} y2={Math.sin(a) * 102} stroke="#fff" strokeWidth="1.5" opacity="0.18" />;
        })}
        <circle cx="0" cy="0" r="92" fill="none" stroke="#fff" strokeWidth="1" opacity="0.08" />
        <circle cx="0" cy="0" r="78" fill="url(#hero-rim)" />
        <circle cx="0" cy="0" r="78" fill="none" stroke="#000" strokeWidth="1.5" opacity="0.5" />
        {Array.from({ length: 5 }).map((_, i) => (
          <g key={i} transform={`rotate(${(i / 5) * 360})`}>
            <path d="M -10 -68 L 10 -68 L 18 -22 L -18 -22 Z" fill="#0f1217" opacity="0.85" />
            <circle cx="0" cy="-58" r="3.5" fill="#9ca3af" />
          </g>
        ))}
        <circle cx="0" cy="0" r="28" fill="url(#hero-hub)" />
        <circle cx="0" cy="0" r="28" fill="none" stroke="#000" strokeWidth="1" opacity="0.4" />
        {Array.from({ length: 5 }).map((_, i) => {
          const a = (i / 5) * Math.PI * 2 - Math.PI / 2;
          return <circle key={i} cx={Math.cos(a) * 18} cy={Math.sin(a) * 18} r="3" fill="#1f2937" />;
        })}
        <circle cx="0" cy="0" r="8" fill="#1f2937" />
        <circle cx="0" cy="0" r="3.5" fill="#ff2800" />
      </g>
      <g transform="translate(570,265)">
        <circle cx="0" cy="0" r="118" fill="url(#hero-tire)" />
        <circle cx="0" cy="0" r="118" fill="none" stroke="#000" strokeWidth="2" opacity="0.6" />
        {Array.from({ length: 28 }).map((_, i) => {
          const a = (i / 28) * Math.PI * 2;
          return <line key={i} x1={Math.cos(a) * 112} y1={Math.sin(a) * 112} x2={Math.cos(a) * 102} y2={Math.sin(a) * 102} stroke="#fff" strokeWidth="1.5" opacity="0.18" />;
        })}
        <circle cx="0" cy="0" r="92" fill="none" stroke="#fff" strokeWidth="1" opacity="0.08" />
        <circle cx="0" cy="0" r="78" fill="url(#hero-rim)" />
        <circle cx="0" cy="0" r="78" fill="none" stroke="#000" strokeWidth="1.5" opacity="0.5" />
        {Array.from({ length: 5 }).map((_, i) => (
          <g key={i} transform={`rotate(${(i / 5) * 360})`}>
            <path d="M -10 -68 L 10 -68 L 18 -22 L -18 -22 Z" fill="#0f1217" opacity="0.85" />
            <circle cx="0" cy="-58" r="3.5" fill="#9ca3af" />
          </g>
        ))}
        <circle cx="0" cy="0" r="28" fill="url(#hero-hub)" />
        <circle cx="0" cy="0" r="28" fill="none" stroke="#000" strokeWidth="1" opacity="0.4" />
        {Array.from({ length: 5 }).map((_, i) => {
          const a = (i / 5) * Math.PI * 2 - Math.PI / 2;
          return <circle key={i} cx={Math.cos(a) * 18} cy={Math.sin(a) * 18} r="3" fill="#1f2937" />;
        })}
        <circle cx="0" cy="0" r="8" fill="#1f2937" />
        <circle cx="0" cy="0" r="3.5" fill="#ff2800" />
      </g>
      <line x1="20" y1="455" x2="700" y2="455" stroke="#fff" strokeOpacity="0.08" strokeWidth="1" />
    </svg>
  );
}

function IllustrationFrame({ children, label }: { children: React.ReactNode; label: string }) {
  return (
    <div className="relative h-44 overflow-hidden bg-gradient-to-br from-[hsl(215_35%_22%)] to-[hsl(215_40%_10%)]">
      <div className="absolute inset-0 opacity-[0.05]" style={{ backgroundImage: "repeating-linear-gradient(45deg, #fff 0 1px, transparent 1px 14px)" }} aria-hidden="true" />
      <div className="absolute top-3 left-4 text-[10px] uppercase tracking-[0.18em] text-white/50 font-semibold">{label}</div>
      <div className="absolute inset-0 flex items-center justify-center">{children}</div>
    </div>
  );
}

export function HubsIllustration() {
  const t = useCopy(COPY);
  return (
    <IllustrationFrame label={t.hubs}>
      <svg viewBox="0 0 240 140" className="h-32 w-auto" aria-hidden="true">
        <defs>
          <linearGradient id="hub-rim-g" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#e5e7eb" />
            <stop offset="100%" stopColor="#6b7280" />
          </linearGradient>
        </defs>
        <circle cx="120" cy="70" r="58" fill="#1a1d22" stroke="#9ca3af" strokeWidth="1.5" />
        <circle cx="120" cy="70" r="58" fill="none" stroke="#fff" strokeWidth="1" opacity="0.12" />
        {Array.from({ length: 16 }).map((_, i) => {
          const a = (i / 16) * Math.PI * 2;
          return <line key={i} x1={120 + Math.cos(a) * 50} y1={70 + Math.sin(a) * 50} x2={120 + Math.cos(a) * 58} y2={70 + Math.sin(a) * 58} stroke="#fff" strokeWidth="1" opacity="0.18" />;
        })}
        <circle cx="120" cy="70" r="36" fill="url(#hub-rim-g)" />
        <circle cx="120" cy="70" r="36" fill="none" stroke="#000" strokeWidth="1" opacity="0.4" />
        {Array.from({ length: 5 }).map((_, i) => {
          const a = (i / 5) * Math.PI * 2 - Math.PI / 2;
          const x = 120 + Math.cos(a) * 22;
          const y = 70 + Math.sin(a) * 22;
          return <g key={i}><circle cx={x} cy={y} r="4.5" fill="#1f2937" /><circle cx={x} cy={y} r="2" fill="#9ca3af" /></g>;
        })}
        <circle cx="120" cy="70" r="9" fill="#0f1217" />
        <circle cx="120" cy="70" r="3.5" fill="#ff2800" />
        <path d="M 60 70 Q 70 50 95 55" stroke="#ff2800" strokeWidth="2" fill="none" strokeLinecap="round" />
        <circle cx="60" cy="70" r="3" fill="#ff2800" />
      </svg>
    </IllustrationFrame>
  );
}

export function SuspensionIllustration() {
  const t = useCopy(COPY);
  return (
    <IllustrationFrame label={t.suspension}>
      <svg viewBox="0 0 240 140" className="h-32 w-auto" aria-hidden="true">
        <rect x="20" y="38" width="200" height="10" fill="#0f1217" stroke="#9ca3af" strokeWidth="0.8" />
        <path d="M 50 48 L 50 76 L 60 86 L 60 48 Z" fill="#9ca3af" />
        <path d="M 180 48 L 180 86 L 190 76 L 190 48 Z" fill="#9ca3af" />
        <path d="M 110 88 L 130 88 L 134 102 L 106 102 Z" fill="#9ca3af" />
        <circle cx="120" cy="95" r="3" fill="#1f2937" />
        <path d="M 55 92 Q 90 76 115 92" stroke="#4b5563" strokeWidth="6" fill="none" strokeLinecap="round" />
        <path d="M 62 96 Q 90 84 110 96" stroke="#4b5563" strokeWidth="4" fill="none" strokeLinecap="round" opacity="0.85" />
        <path d="M 70 100 Q 90 92 105 100" stroke="#4b5563" strokeWidth="3" fill="none" strokeLinecap="round" opacity="0.7" />
        <path d="M 125 92 Q 160 76 185 92" stroke="#4b5563" strokeWidth="6" fill="none" strokeLinecap="round" />
        <path d="M 130 96 Q 160 84 180 96" stroke="#4b5563" strokeWidth="4" fill="none" strokeLinecap="round" opacity="0.85" />
        <path d="M 140 100 Q 160 92 175 100" stroke="#4b5563" strokeWidth="3" fill="none" strokeLinecap="round" opacity="0.7" />
        <rect x="78" y="78" width="3" height="28" fill="#1f2937" />
        <rect x="100" y="78" width="3" height="28" fill="#1f2937" />
        <rect x="148" y="78" width="3" height="28" fill="#1f2937" />
        <rect x="170" y="78" width="3" height="28" fill="#1f2937" />
        <rect x="74" y="106" width="32" height="6" fill="#0f1217" />
        <rect x="146" y="106" width="32" height="6" fill="#0f1217" />
        <circle cx="55" cy="92" r="3.5" fill="#ff2800" />
        <circle cx="115" cy="92" r="3.5" fill="#ff2800" />
        <circle cx="125" cy="92" r="3.5" fill="#ff2800" />
        <circle cx="185" cy="92" r="3.5" fill="#ff2800" />
      </svg>
    </IllustrationFrame>
  );
}

export function JacksCouplersIllustration() {
  const t = useCopy(COPY);
  return (
    <IllustrationFrame label={t.jacks}>
      <svg viewBox="0 0 240 140" className="h-32 w-auto" aria-hidden="true">
        <g>
          <path d="M 12 78 L 60 78 L 70 64 L 90 64 L 90 92 L 70 92 L 60 78 Z" fill="#0f1217" stroke="#9ca3af" strokeWidth="1" />
          <circle cx="80" cy="78" r="6" fill="#ff2800" />
          <rect x="68" y="58" width="24" height="6" fill="#9ca3af" />
        </g>
        <rect x="90" y="74" width="40" height="8" fill="#0f1217" stroke="#9ca3af" strokeWidth="0.8" />
        <g>
          <rect x="135" y="20" width="22" height="74" rx="2" fill="#9ca3af" />
          <rect x="135" y="20" width="22" height="74" rx="2" fill="none" stroke="#000" strokeWidth="0.8" opacity="0.4" />
          <rect x="139" y="24" width="14" height="66" fill="#0f1217" opacity="0.5" />
          <circle cx="146" cy="20" r="6" fill="#0f1217" stroke="#9ca3af" strokeWidth="1" />
          <rect x="144" y="6" width="4" height="14" fill="#9ca3af" />
          <circle cx="146" cy="6" r="3" fill="#ff2800" />
          <rect x="142" y="94" width="8" height="34" fill="#0f1217" />
          <rect x="132" y="126" width="28" height="6" rx="1" fill="#9ca3af" />
        </g>
        <rect x="124" y="78" width="34" height="6" fill="#1f2937" />
      </svg>
    </IllustrationFrame>
  );
}

export function TiresWheelsIllustration() {
  const t = useCopy(COPY);
  return (
    <IllustrationFrame label={t.tires}>
      <svg viewBox="0 0 240 140" className="h-32 w-auto" aria-hidden="true">
        <defs>
          <linearGradient id="tw-rim" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#f3f4f6" />
            <stop offset="100%" stopColor="#6b7280" />
          </linearGradient>
        </defs>
        <circle cx="120" cy="70" r="56" fill="#0f1217" />
        <circle cx="120" cy="70" r="56" fill="none" stroke="#000" strokeWidth="1" opacity="0.6" />
        {Array.from({ length: 24 }).map((_, i) => {
          const a = (i / 24) * Math.PI * 2;
          return <line key={i} x1={120 + Math.cos(a) * 54} y1={70 + Math.sin(a) * 54} x2={120 + Math.cos(a) * 48} y2={70 + Math.sin(a) * 48} stroke="#fff" strokeWidth="1.2" opacity="0.22" />;
        })}
        <circle cx="120" cy="70" r="44" fill="none" stroke="#fff" strokeWidth="0.6" opacity="0.15" />
        <circle cx="120" cy="70" r="38" fill="url(#tw-rim)" />
        <circle cx="120" cy="70" r="38" fill="none" stroke="#000" strokeWidth="1" opacity="0.5" />
        {Array.from({ length: 5 }).map((_, i) => (
          <g key={i} transform={`rotate(${(i / 5) * 360} 120 70)`}>
            <path d="M 116 38 L 124 38 L 130 62 L 110 62 Z" fill="#0f1217" opacity="0.9" />
          </g>
        ))}
        <circle cx="120" cy="70" r="14" fill="#1f2937" />
        <circle cx="120" cy="70" r="5" fill="#ff2800" />
        {Array.from({ length: 5 }).map((_, i) => {
          const a = (i / 5) * Math.PI * 2 - Math.PI / 2;
          return <circle key={i} cx={120 + Math.cos(a) * 22} cy={70 + Math.sin(a) * 22} r="2.5" fill="#9ca3af" />;
        })}
      </svg>
    </IllustrationFrame>
  );
}

export function ApplicationIcon({ kind, className }: { kind: string; className?: string }) {
  const common = { className, viewBox: "0 0 64 32", "aria-hidden": true } as const;
  const fill = "currentColor";
  switch (kind) {
    case "utility":
      return (
        <svg {...common}>
          <rect x="4" y="14" width="46" height="6" fill={fill} />
          <rect x="2" y="12" width="6" height="10" fill={fill} />
          <circle cx="18" cy="24" r="5" fill={fill} />
          <circle cx="40" cy="24" r="5" fill={fill} />
        </svg>
      );
    case "cargo":
      return (
        <svg {...common}>
          <rect x="6" y="4" width="50" height="20" fill={fill} />
          <circle cx="18" cy="28" r="4" fill={fill} />
          <circle cx="44" cy="28" r="4" fill={fill} />
        </svg>
      );
    case "boat":
      return (
        <svg {...common}>
          <path d="M 4 18 L 60 18 L 54 24 L 10 24 Z" fill={fill} />
          <path d="M 14 6 L 50 6 L 56 18 L 8 18 Z" fill={fill} opacity="0.85" />
          <circle cx="20" cy="28" r="3.5" fill={fill} />
          <circle cx="44" cy="28" r="3.5" fill={fill} />
        </svg>
      );
    case "rv":
      return (
        <svg {...common}>
          <path d="M 4 22 L 4 10 L 30 10 L 36 6 L 60 6 L 60 22 Z" fill={fill} />
          <circle cx="16" cy="26" r="4" fill={fill} />
          <circle cx="48" cy="26" r="4" fill={fill} />
        </svg>
      );
    case "ag":
      return (
        <svg {...common}>
          <rect x="14" y="10" width="36" height="10" fill={fill} />
          <circle cx="14" cy="22" r="6" fill={fill} />
          <circle cx="48" cy="24" r="8" fill={fill} />
        </svg>
      );
    case "commercial":
      return (
        <svg {...common}>
          <rect x="2" y="8" width="36" height="16" fill={fill} />
          <path d="M 38 12 L 56 12 L 60 18 L 60 24 L 38 24 Z" fill={fill} opacity="0.85" />
          <circle cx="14" cy="28" r="3.5" fill={fill} />
          <circle cx="46" cy="28" r="3.5" fill={fill} />
        </svg>
      );
    default:
      return null;
  }
}
